import React from 'react';
import { PageTitle, SectionTitle } from '../../components/PageTitle/PageTitle.styled';
import { MixTelematictsStyled } from './MixTelematicts.styled';
import Container from '../../components/Container/Container';
import { CardText } from '../../components/Card/Card.styled';
import Card from '../../components/Card/Card';
import FormRequest from '../../components/Form/FormRequest';
import CompanyCard from '../../components/CompanyCard/CompanyCard';
import companyLogo from '../../assets/images/logo/mixtelematics.svg';
import companyImage from '../../assets/images/companies/mix-telematics.png';
// @ts-ignore
import SEO from '@americanexpress/react-seo';

function MixTelematicts(): JSX.Element {
  return (
    <MixTelematictsStyled>
      <SEO
        title="RGRauto | MiX Telematics"
      />
      <Container>
        <PageTitle>MiX Telematics</PageTitle>
        <CompanyCard
          name="MiX Telematics"
          logo={companyLogo}
          image={companyImage}
          buttons={[
            {
              title: 'MyMiX Tracking™',
              url: '/mix-telematics/mix-tracking',
            },
            {
              title: 'MiX Fleet Manager™',
              url: '/mix-telematics/mix-fleet-manager',
            },
            {
              title: 'MiX Vision II™',
              url: '/mix-telematics/mix-vision-ii',
            },
          ]}
        >
          <p>
              MiX Telematics
          </p>
          <p>
              MyMiX Tracking™, MiX Fleet Manager™, MiX Vision II™
          </p>
        </CompanyCard>
        <Card>
          <SectionTitle>Request a demo</SectionTitle>
          <CardText>
            To request a demo, please complete the form below <br />
            and we will contact you as soon as possible
          </CardText>
          <FormRequest />
        </Card>
      </Container>
    </MixTelematictsStyled>
  );
}

export default MixTelematicts;
